import { css } from '@emotion/react';

const makeStackedBackButtonStyles = (theme) => {
  return {
    box: css({
      height: 40,
      width: 40,
      marginBottom: theme.mvf.spacing.small,
    }),
  };
};

export default makeStackedBackButtonStyles;
